// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileBulkFollowModal-cls1_eaA","cls2":"ProfileBulkFollowModal-cls2__eQ ProfileBulkFollowModal-cls1_eaA"};